module.exports = __webpack_public_path__ + "img/00_base_1210mk2_VG+.27e2da2b.png";